import {Component, Input, OnInit} from '@angular/core';
import {QuestionModel} from '../../../../../models/questions/question.model';
import {SectionQuestionResult, SectionResult} from '../../placement-group-view.component';
import {TranslateService} from '@ngx-translate/core';
import {PlacementTestSectionModel, PlacementTestSectionQuestionModel} from '../../../../../models/edu-admin/placement-test.model';
import {UserModel} from '../../../../../models/authentication/user.model';
import {CultureModel} from '../../../../../models/localization-and-pricing/culture.model';

@Component({
  selector: 'app-placement-group-skill-card-detailed',
  templateUrl: './placement-group-skill-card-detailed.component.html',
  styleUrls: ['./placement-group-skill-card-detailed.component.css']
})
export class PlacementGroupSkillCardDetailedComponent implements OnInit {

  /**
   * Index is used to display number what the skill card is
   * in the ordered list of skills to work on in the placement test
   */
  @Input() index: number;

  /**
   * The number of students are required to show averages for the
   * students in the group.
   */
  @Input() numStudents: number;

  /**
   * We need to get the question of the placement test section question
   */
  @Input() placementSectionQ: PlacementTestSectionQuestionModel;

  /**
   * The aggregated data for the section question where we have
   * aggreated the num failed, num practised and num mastered
   * based on the mastery after the placement test
   */
  @Input() sectionQuestionResult: SectionQuestionResult;

  constructor(public tSv: TranslateService) { }

  static cardWidth(): number {
    return 358;
  }

  static cardHeight(): number {

    return 180;
  }

  ngOnInit() {
  }

  numPassed(): string {

    if (this.sectionQuestionResult) {
      return this.sectionQuestionResult.numPassed().toString(10);
    }

    return '0';

  }

  numFailed(): string {

    if (this.sectionQuestionResult) {

      return this.sectionQuestionResult.numFailed.toString(10);
    }

    return '0';

  }

  numPractising(): string {

    if (this.sectionQuestionResult) {

      return this.sectionQuestionResult.numPractising.toString(10);
    }

    return '0';
  }

  numMastered(): string {


    if (this.sectionQuestionResult) {

      return this.sectionQuestionResult.numMastered.toString(10);
    }

    return '0';

  }

  divideByStudents(value: number): number {

    if (this.numStudents === 0) {
      return 0;
    }

    return value / this.numStudents * 100;

  }

  userCulture(): string {

    if (UserModel.getCurrent()) {
      return UserModel.getCurrent().culture;
    }

    return CultureModel.enGB;
  }

}
